import React, { useEffect, useState } from 'react';
import { Input, Select } from '../../../components/ui/Input';
import Secao from '../../../components/ui/Secao';
import { COLORS } from '../../../theme';

const UFS = ['AC','AL','AP','AM','BA','CE','DF','ES','GO','MA','MT','MS','MG','PA','PB','PR','PE','PI','RJ','RN','RS','RO','RR','SC','SP','SE','TO'];
const OPCOES_UF = [{ value: '', label: '' }, ...UFS.map(uf => ({ value: uf, label: uf }))];

function CamposEndereco({ prefixo, form, onChange, desabilitado }) {
  return (
    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: 6 }}>
      <Input label="CEP" value={form[`${prefixo}_cep`] || ''} onChange={e => onChange(`${prefixo}_cep`, e.target.value)} disabled={desabilitado} />
      <Input label="Logradouro" style={{ gridColumn: 'span 2' }} value={form[`${prefixo}_logradouro`] || ''} onChange={e => onChange(`${prefixo}_logradouro`, e.target.value)} disabled={desabilitado} />
      <Input label="Número" value={form[`${prefixo}_numero`] || ''} onChange={e => onChange(`${prefixo}_numero`, e.target.value)} disabled={desabilitado} />
      <Input label="Complemento" value={form[`${prefixo}_complemento`] || ''} onChange={e => onChange(`${prefixo}_complemento`, e.target.value)} disabled={desabilitado} />
      <Input label="Bairro" value={form[`${prefixo}_bairro`] || ''} onChange={e => onChange(`${prefixo}_bairro`, e.target.value)} disabled={desabilitado} />
      <Input label="Cidade" value={form[`${prefixo}_cidade`] || ''} onChange={e => onChange(`${prefixo}_cidade`, e.target.value)} disabled={desabilitado} />
      <Select label="UF" options={OPCOES_UF} value={form[`${prefixo}_uf`] || ''} onChange={e => onChange(`${prefixo}_uf`, e.target.value)} disabled={desabilitado} />
    </div>
  );
}

const OPCOES_FRETE = [
  { value: '', label: 'Não definido' },
  { value: 'fob', label: 'FOB (comprador paga o frete)' },
  { value: 'cif', label: 'CIF (fornecedor paga o frete)' }
];

export default function DadosGeraisTab({ form, onChange, exibirEnderecosExtras = true, exibirFrete = false, exibirPrazoEntrega = false }) {
  const [mesmoEntrega, setMesmoEntrega] = useState(false);
  const [mesmoCobranca, setMesmoCobranca] = useState(false);

  const copiarPrincipal = (prefixoDestino) => {
    ['cep', 'logradouro', 'numero', 'complemento', 'bairro', 'cidade', 'uf'].forEach(campo => {
      onChange(`${prefixoDestino}_${campo}`, form[`end_principal_${campo}`] || '');
    });
  };

  useEffect(() => {
    if (mesmoEntrega) copiarPrincipal('end_entrega');
  }, [mesmoEntrega, form.end_principal_cep, form.end_principal_logradouro, form.end_principal_numero, form.end_principal_complemento, form.end_principal_bairro, form.end_principal_cidade, form.end_principal_uf]); // eslint-disable-line

  useEffect(() => {
    if (mesmoCobranca) copiarPrincipal('end_cobranca');
  }, [mesmoCobranca, form.end_principal_cep, form.end_principal_logradouro, form.end_principal_numero, form.end_principal_complemento, form.end_principal_bairro, form.end_principal_cidade, form.end_principal_uf]); // eslint-disable-line

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
      <Secao titulo="Identificação">
        <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
          <div style={{ display: 'grid', gridTemplateColumns: '2fr 2fr 1fr', gap: 6 }}>
            <Input label="Nome Fantasia" value={form.nome_fantasia || ''} onChange={e => onChange('nome_fantasia', e.target.value)} required />
            <Input label="Razão Social" value={form.razao_social || ''} onChange={e => onChange('razao_social', e.target.value)} />
            <Input label="CNPJ/CPF" value={form.cnpj_cpf || ''} onChange={e => onChange('cnpj_cpf', e.target.value)} />
          </div>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 6, alignItems: 'end' }}>
            <Input label="Inscrição Estadual" value={form.ie || ''} onChange={e => onChange('ie', e.target.value)} disabled={!!form.ie_isento} />
            <label style={{ display: 'flex', alignItems: 'center', gap: 8, fontSize: 13, paddingBottom: 9 }}>
              <input type="checkbox" checked={!!form.ie_isento} onChange={e => onChange('ie_isento', e.target.checked ? 1 : 0)} />
              Isento de IE
            </label>
            <Input label="Inscrição Municipal" value={form.im || ''} onChange={e => onChange('im', e.target.value)} />
          </div>
          {(exibirFrete || exibirPrazoEntrega) && (
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 6, maxWidth: 420 }}>
              {exibirFrete && (
                <Select label="Tipo de Frete" options={OPCOES_FRETE} value={form.tipo_frete || ''} onChange={e => onChange('tipo_frete', e.target.value || null)} />
              )}
              {exibirPrazoEntrega && (
                <Input label="Prazo Médio de Entrega (dias)" type="number" min="0" value={form.prazo_medio_entrega_dias || ''} onChange={e => onChange('prazo_medio_entrega_dias', e.target.value)} />
              )}
            </div>
          )}
        </div>
      </Secao>

      <Secao titulo="Contato Principal">
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 6 }}>
          <Input label="Nome" value={form.contato_nome || ''} onChange={e => onChange('contato_nome', e.target.value)} />
          <Input label="Email" type="email" value={form.contato_email || ''} onChange={e => onChange('contato_email', e.target.value)} />
          <Input label="Site" value={form.contato_site || ''} onChange={e => onChange('contato_site', e.target.value)} />
        </div>
      </Secao>

      <Secao titulo="Telefones">
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 6 }}>
          <Input label="Telefone 1" value={form.telefone1 || ''} onChange={e => onChange('telefone1', e.target.value)} />
          <Input label="Telefone 2" value={form.telefone2 || ''} onChange={e => onChange('telefone2', e.target.value)} />
          <Input label="Telefone 3" value={form.telefone3 || ''} onChange={e => onChange('telefone3', e.target.value)} />
        </div>
      </Secao>

      <Secao titulo="Endereço Principal">
        <CamposEndereco prefixo="end_principal" form={form} onChange={onChange} />
      </Secao>

      {exibirEnderecosExtras && (
        <>
          <Secao
            titulo="Endereço de Entrega"
            acao={
              <label style={{ display: 'flex', alignItems: 'center', gap: 8, fontSize: 12, color: COLORS.textMid, textTransform: 'none', letterSpacing: 'normal', fontWeight: 400 }}>
                <input type="checkbox" checked={mesmoEntrega} onChange={e => setMesmoEntrega(e.target.checked)} />
                Mesmo do principal
              </label>
            }
          >
            <CamposEndereco prefixo="end_entrega" form={form} onChange={onChange} desabilitado={mesmoEntrega} />
          </Secao>

          <Secao
            titulo="Endereço de Cobrança"
            acao={
              <label style={{ display: 'flex', alignItems: 'center', gap: 8, fontSize: 12, color: COLORS.textMid, textTransform: 'none', letterSpacing: 'normal', fontWeight: 400 }}>
                <input type="checkbox" checked={mesmoCobranca} onChange={e => setMesmoCobranca(e.target.checked)} />
                Mesmo do principal
              </label>
            }
          >
            <CamposEndereco prefixo="end_cobranca" form={form} onChange={onChange} desabilitado={mesmoCobranca} />
          </Secao>
        </>
      )}
    </div>
  );
}
